import axios from '@/libs/axios';
import { ExtractFnReturnType, QueryConfig } from '@/libs/react-query';
import { Response } from '@/types/response';
import { useQuery } from '@tanstack/react-query';
import { ListQueryKey, Urls } from '../constant';
import { Coin } from '../types';

//
export interface SelectRequest {
  id?: string;
  date?: string[];
  pageIndex?: number;
  pageSize?: number;
}

export interface SelectResponse extends Response {
  data: {
    total: number;
    items: Coin[];
  };
}

//
export const selection = (data: SelectRequest): Promise<SelectResponse> => {
  return axios.post(Urls.selectUrl, {
    page: data.pageIndex,
    page_size: data.pageSize,
    orders: {
      created_at: {
        desc: true,
        enable: true,
      },
    },
  });
};

type QueryFnType = typeof selection;

interface useSelectOptions {
  params: SelectRequest;
  config?: QueryConfig<QueryFnType>;
}

//
export const useSelect = ({ params, config }: useSelectOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>(
    [ListQueryKey, params],
    () => selection(params),
    config
  );
};
